import useTranslateData from './use-translate-data';
import useTranslate from './use-translate';
import useSocketEventOnTranslate from './socket-event-on-translate';
import useTranslateQuota from './use-translate-quota';

export default { useTranslateData, useTranslate, useSocketEventOnTranslate, useTranslateQuota };

export { useTranslateData, useTranslate, useSocketEventOnTranslate, useTranslateQuota };
